/**
 * Render the HeadRow component - i.e. the table head row with the weekday
 * names.
 */
export default function HeadRow() {
  const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]

  return (
    <tr className="type-body-9 text-neutral-700">
      {weekdays.map((weekday, i) => (
        <th key={i} scope="col" className="text-center" aria-label={weekday}>
          {weekday.slice(0, 2)}
        </th>
      ))}
    </tr>
  )
}
